var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementNavigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "element-navigation",
    transform: "translate(19869 21959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5449",
    "data-name": "Gruppe 5449",
    transform: "translate(-19869 -21959)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_296",
    "data-name": "Ellipse 296",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(13)",
    fill: "#304785"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_297",
    "data-name": "Ellipse 297",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(29 42)",
    fill: "#6a82c5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_298",
    "data-name": "Ellipse 298",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(0 36)",
    fill: "#ff5560"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementNavigation);
export default __webpack_public_path__ + "static/media/element-navigation.fd66fcaa4139acba9da84e715e4478b0.svg";
export { ForwardRef as ReactComponent };